import styled from 'styled-components';

const PsnRegionBlocked = styled.span`
  font-weight: bold;
  font-size: 1.4em;
  color: yellow;
  font-family: BurbankBigRegular-Black, sans-serif;
  text-transform: uppercase;
`;

export default PsnRegionBlocked;
